/**
 * 模拟站点数据
 * 沙洋县政务服务中心站点信息
 */

// 站点类型字典
export const siteDictList = [
  { dictValue: '1', dictLabel: '市级' },
  { dictValue: '2', dictLabel: '县级' },
  { dictValue: '3', dictLabel: '镇级' },
  { dictValue: '4', dictLabel: '村/社区' }
];

// 站点列表数据
export const siteList = [
  {
    id: 1,
    centerguid: 'center-001',
    siteName: '沙洋县政务服务中心',
    address: '沙洋县汉津大道88号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐公交1路、2路至县政务中心站下车',
    phone: '0724-8528888',
    lng: '112.588456',
    lat: '30.709234',
    distance: '0.5',
    areaLevel: '2'
  },
  {
    id: 2,
    centerguid: 'center-002',
    siteName: '沙洋镇便民服务中心',
    address: '沙洋县沙洋镇长林路12号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐公交1路至沙洋镇政府站下车',
    phone: '0724-8512345',
    lng: '112.592345',
    lat: '30.712456',
    distance: '1.2',
    areaLevel: '3'
  },
  {
    id: 3,
    centerguid: 'center-003',
    siteName: '后港镇便民服务中心',
    address: '沙洋县后港镇荆潜路56号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至后港镇政府站下车',
    phone: '0724-8623456',
    lng: '112.456789',
    lat: '30.623456',
    distance: '15.8',
    areaLevel: '3'
  },
  {
    id: 4,
    centerguid: 'center-004',
    siteName: '毛李镇便民服务中心',
    address: '沙洋县毛李镇毛李大道18号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至毛李镇政府站下车',
    phone: '0724-8734567',
    lng: '112.398765',
    lat: '30.589012',
    distance: '22.5',
    areaLevel: '3'
  },
  {
    id: 5,
    centerguid: 'center-005',
    siteName: '拾回桥镇便民服务中心',
    address: '沙洋县拾回桥镇中心街28号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至拾回桥镇政府站下车',
    phone: '0724-8845678',
    lng: '112.512345',
    lat: '30.756789',
    distance: '12.3',
    areaLevel: '3'
  },
  {
    id: 6,
    centerguid: 'center-006',
    siteName: '五里铺镇便民服务中心',
    address: '沙洋县五里铺镇五里大道66号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至五里铺镇政府站下车',
    phone: '0724-8956789',
    lng: '112.623456',
    lat: '30.678901',
    distance: '8.6',
    areaLevel: '3'
  },
  {
    id: 7,
    centerguid: 'center-007',
    siteName: '十里铺镇便民服务中心',
    address: '沙洋县十里铺镇振兴路15号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至十里铺镇政府站下车',
    phone: '0724-8067890',
    lng: '112.534567',
    lat: '30.698765',
    distance: '6.5',
    areaLevel: '3'
  },
  {
    id: 8,
    centerguid: 'center-008',
    siteName: '纪山镇便民服务中心',
    address: '沙洋县纪山镇纪山大道22号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至纪山镇政府站下车',
    phone: '0724-8178901',
    lng: '112.478901',
    lat: '30.645678',
    distance: '18.2',
    areaLevel: '3'
  },
  {
    id: 9,
    centerguid: 'center-009',
    siteName: '曾集镇便民服务中心',
    address: '沙洋县曾集镇曾集街38号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至曾集镇政府站下车',
    phone: '0724-8289012',
    lng: '112.645678',
    lat: '30.734567',
    distance: '10.8',
    areaLevel: '3'
  },
  {
    id: 10,
    centerguid: 'center-010',
    siteName: '高阳镇便民服务中心',
    address: '沙洋县高阳镇高阳大道45号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至高阳镇政府站下车',
    phone: '0724-8390123',
    lng: '112.567890',
    lat: '30.812345',
    distance: '16.5',
    areaLevel: '3'
  },
  {
    id: 11,
    centerguid: 'center-011',
    siteName: '李市镇便民服务中心',
    address: '沙洋县李市镇李市街52号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至李市镇政府站下车',
    phone: '0724-8401234',
    lng: '112.689012',
    lat: '30.656789',
    distance: '14.2',
    areaLevel: '3'
  },
  {
    id: 12,
    centerguid: 'center-012',
    siteName: '马良镇便民服务中心',
    address: '沙洋县马良镇马良大道33号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至马良镇政府站下车',
    phone: '0724-8512345',
    lng: '112.423456',
    lat: '30.567890',
    distance: '25.6',
    areaLevel: '3'
  },
  {
    id: 13,
    centerguid: 'center-013',
    siteName: '官垱镇便民服务中心',
    address: '沙洋县官垱镇官垱街18号',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '乘坐城乡公交至官垱镇政府站下车',
    phone: '0724-8623456',
    lng: '112.356789',
    lat: '30.612345',
    distance: '28.3',
    areaLevel: '3'
  },
  {
    id: 14,
    centerguid: 'center-014',
    siteName: '汉津社区便民服务站',
    address: '沙洋县沙洋镇汉津社区居委会',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '步行至汉津社区服务站',
    phone: '0724-8734567',
    lng: '112.586789',
    lat: '30.707890',
    distance: '0.8',
    areaLevel: '4'
  },
  {
    id: 15,
    centerguid: 'center-015',
    siteName: '洪岭社区便民服务站',
    address: '沙洋县沙洋镇洪岭社区居委会',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '步行至洪岭社区服务站',
    phone: '0724-8845678',
    lng: '112.595678',
    lat: '30.715678',
    distance: '1.5',
    areaLevel: '4'
  },
  {
    id: 16,
    centerguid: 'center-016',
    siteName: '平湖社区便民服务站',
    address: '沙洋县沙洋镇平湖社区居委会',
    time: '周一至周五 8:30-12:00 14:30-17:30',
    traffic: '步行至平湖社区服务站',
    phone: '0724-8956789',
    lng: '112.582345',
    lat: '30.703456',
    distance: '1.0',
    areaLevel: '4'
  }
];

// 热门搜索记录
export const hotSearchList = [
  { id: 1, searchWord: '身份证办理', searchType: 2 },
  { id: 2, searchWord: '社保查询', searchType: 2 },
  { id: 3, searchWord: '公积金', searchType: 2 },
  { id: 4, searchWord: '县政务中心', searchType: 1 },
  { id: 5, searchWord: '营业执照', searchType: 2 },
  { id: 6, searchWord: '不动产登记', searchType: 2 }
];

// 用户搜索记录
export const searchRecordList = [
  { id: 1, searchWord: '沙洋镇', phone: '13476129309' },
  { id: 2, searchWord: '社保', phone: '13476129309' },
  { id: 3, searchWord: '县政务中心', phone: '13476129309' }
];


// 事项列表数据
export const itemList = [
  { id: 1, name: '身份证办理', category: '户籍身份', recommend: 'hall', handleWays: ['hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 2, name: '社保卡办理', category: '社保公积金', recommend: 'self', handleWays: ['self', 'hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 3, name: '医保报销', category: '医疗健康', recommend: 'mobile', handleWays: ['mobile', 'pc', 'hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 4, name: '公积金提取', category: '社保公积金', recommend: 'mobile', handleWays: ['mobile', 'pc', 'self'], siteIds: [1] },
  { id: 5, name: '营业执照办理', category: '企业服务', recommend: 'pc', handleWays: ['pc', 'hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 6, name: '社保查询', category: '社保公积金', recommend: 'mobile', handleWays: ['mobile', 'pc', 'self'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16] },
  { id: 7, name: '不动产登记', category: '不动产', recommend: 'hall', handleWays: ['pc', 'hall'], siteIds: [1] },
  { id: 8, name: '户籍迁移', category: '户籍身份', recommend: 'hall', handleWays: ['hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 9, name: '生育登记', category: '婚育收养', recommend: 'mobile', handleWays: ['mobile', 'pc'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 10, name: '税务申报', category: '企业服务', recommend: 'pc', handleWays: ['mobile', 'pc'], siteIds: [1] },
  { id: 11, name: '驾驶证换领', category: '交通出行', recommend: 'self', handleWays: ['mobile', 'self', 'hall'], siteIds: [1] },
  { id: 12, name: '居住证办理', category: '户籍身份', recommend: 'hall', handleWays: ['pc', 'hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 13, name: '婚姻登记', category: '婚育收养', recommend: 'hall', handleWays: ['hall'], siteIds: [1] },
  { id: 14, name: '出生证明', category: '婚育收养', recommend: 'hall', handleWays: ['hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 15, name: '养老保险查询', category: '社保公积金', recommend: 'mobile', handleWays: ['mobile', 'pc', 'self'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16] },
  { id: 16, name: '医保卡挂失', category: '医疗健康', recommend: 'mobile', handleWays: ['mobile', 'hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 17, name: '企业注销', category: '企业服务', recommend: 'pc', handleWays: ['pc', 'hall'], siteIds: [1] },
  { id: 18, name: '房产过户', category: '不动产', recommend: 'hall', handleWays: ['hall'], siteIds: [1] },
  { id: 19, name: '车辆年检预约', category: '交通出行', recommend: 'mobile', handleWays: ['mobile', 'self'], siteIds: [1] },
  { id: 20, name: '学历认证', category: '教育培训', recommend: 'pc', handleWays: ['pc'], siteIds: [1] },
  { id: 21, name: '农村宅基地审批', category: '农业农村', recommend: 'hall', handleWays: ['hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 22, name: '农机购置补贴', category: '农业农村', recommend: 'hall', handleWays: ['hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13] },
  { id: 23, name: '新农合报销', category: '医疗健康', recommend: 'hall', handleWays: ['mobile', 'hall'], siteIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16] }
];

/**
 * 根据区域级别筛选站点
 * @param {string} areaLevel - 区域级别
 * @returns {Array} 筛选后的站点列表
 */
export function getSitesByAreaLevel(areaLevel) {
  if (!areaLevel) return [...siteList];
  return siteList.filter(site => site.areaLevel === areaLevel);
}

/**
 * 根据关键词搜索站点
 * @param {string} keyword - 搜索关键词
 * @returns {Array} 搜索结果
 */
export function searchSites(keyword) {
  if (!keyword) return [];
  return siteList.filter(site => 
    site.siteName.includes(keyword) || 
    site.address.includes(keyword)
  );
}

// 智能搜索词库

// 1. 纠错词库（错误词 -> 正确词）
export const correctionDict = {
  '核算检测': '核酸检测',
  '身分证': '身份证',
  '户口薄': '户口簿',
  '社宝': '社保',
  '公鸡金': '公积金',
  '医宝': '医保',
  '不动产等级': '不动产登记',
  '营业直照': '营业执照',
  '驾驶正': '驾驶证',
  '居住正': '居住证'
};

// 2. 百姓体转化词库（白话 -> 官方术语）
export const colloquialDict = {
  '办身份证': '身份证办理',
  '换身份证': '身份证办理',
  '办社保卡': '社保卡办理',
  '查社保': '社保查询',
  '取公积金': '公积金提取',
  '报销医保': '医保报销',
  '开店': '营业执照办理',
  '开公司': '营业执照办理',
  '买房过户': '房产过户',
  '房子过户': '房产过户',
  '迁户口': '户籍迁移',
  '落户': '户籍迁移',
  '办居住证': '居住证办理',
  '换驾照': '驾驶证换领',
  '结婚': '婚姻登记',
  '领证': '婚姻登记',
  '生孩子': '生育登记',
  '报税': '税务申报',
  '年检': '车辆年检预约',
  '盖房子': '农村宅基地审批',
  '买农机': '农机购置补贴'
};

// 3. 拼音词库（拼音 -> 中文）
export const pinyinDict = {
  'shebao': '社保',
  'gongjijin': '公积金',
  'yibao': '医保',
  'shenfenzheng': '身份证',
  'hukou': '户口',
  'huji': '户籍',
  'jiashizheng': '驾驶证',
  'yingyezhizhao': '营业执照',
  'budongchan': '不动产',
  'hunyin': '婚姻',
  'shengyu': '生育',
  'juzhuzhen': '居住证',
  'shuiwu': '税务',
  'shayang': '沙洋',
  'nongji': '农机'
};

export default {
  siteDictList,
  siteList,
  hotSearchList,
  searchRecordList,
  itemList,
  getSitesByAreaLevel,
  searchSites,
  correctionDict,
  colloquialDict,
  pinyinDict
};
